import {
  takeEvery, call, put,
} from 'redux-saga/effects';
import {
  availableCountriesRequest, availableCountriesSuccess, availableCountriesFailure,
} from '../../slices/user';
import axios from '../axiosConfig';

const queryString = require('query-string');

function* availableCountriesWorker(action) {
  try {
    const config = {
      method: 'get',
      url: `geo/getCountries?${queryString.stringify(action.payload, { skipNull: true })}`,
    };
    const { data } = yield call(axios, config);
    yield put(availableCountriesSuccess(data));
  } catch (error) {
    yield put(availableCountriesFailure(error));
  }
}

function* availableCountriesWatcher() {
  yield takeEvery(availableCountriesRequest.toString(), availableCountriesWorker);
}

export default availableCountriesWatcher;
